import moment from "moment";
import {
    NewsCategory,
    newsCategoryTitles,
} from "../../../types/news/enums/NewsCategory";
import {
    NewsLabel,
    newsLabelTitles,
} from "../../../types/news/enums/NewsLabel";
import {
    NewsProvider,
    newsProviderTitles,
} from "../../../types/news/enums/NewsProvider";
import { compareStrings } from "../../../utils/compare.utils";

export const constants = {
    maxSearchLengthToIgnore: 2,
    newsLoadCount: 20,
};

export const defaultNews = {
    title: "",
    category: NewsCategory.None,
    label: NewsLabel.None,
    description: null,
    newsDateTime: moment.utc().toISOString(),
};

export const newsLabelValues = Object.keys(newsLabelTitles).map((key) => ({
    id: key,
    label: newsLabelTitles[key as NewsLabel],
})).sort((a, b) => compareStrings(a.label, b.label));

export const newsCategoryValues = Object.keys(newsCategoryTitles).map(
    (key) => ({
        id: key,
        label: newsCategoryTitles[key as NewsCategory],
    })
).sort((a, b) => compareStrings(a.label, b.label));

export const newsProviderValues = Object.keys(newsProviderTitles).map(
    (key) => ({
        id: key,
        label: newsProviderTitles[key as NewsProvider],
    })
);
